import { render, staticRenderFns } from "./tipo_cliente.vue?vue&type=template&id=1b1c0bfa&"
import script from "./tipo_cliente.vue?vue&type=script&lang=js&"
export * from "./tipo_cliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports